import React, { useEffect, useState } from "react";
import MessageModal from "../Modal/MessageModal";
import EditUserModal from "../Modal/EditUserModal";
import {
  ChevronsUpDown,
  EllipsisVertical,
  FolderOutput,
  MessageSquareShare,
  RefreshCw,
  Trash2,
} from "lucide-react";
import DeleteModal from "../Modal/DeleteModal";
import { can_visit, convertDateWithSlash } from "../../helpers";
import classNames from "classnames";
import Skeleton from "react-loading-skeleton";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function UsersDataTable(props) {
  const {
    allProviders = [],
    tableData = [],
    handleCheckboxChange = () => {},
    handleUpdatedInvitedUserInfo = () => {},
    handleSelectAll = () => {},
    selectAll = false,
    handleDeleteRecord = () => {},
    handleResend = () => {},
    messageTemplate = [],
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {},
    userRoles = [],
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {}
  } = props;

  const [orderBy, setOrderBy] = useState();
  const [editUserModal, setEditUserModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [viewStatusOptions, setViewStatusOptions] = useState({});
  const [deleteRecord, setDeleteRecord] = useState({});
  const [activeDeleteModal, setActiveDeleteModal] = useState(false);

  const getProviderNamesByIds = (linked_providers) => {
    return linked_providers.map(id => {
            const provider = allProviders.find(item => item.provider_id === id);
            return provider ? `<span class="docpro_badge docpro_badge_blue docpro_fs_12 ">${provider.first_name} ${provider.last_name}</span><br>` : "";
        })
        .filter(Boolean) // remove empty strings
        .join("");
  }

  const handleCloseEditUserModal = () => {
    setEditUserModal(false);
    window.scrollTo(0, previousScrollPosition);
    setSelectedUser({});
  };

  const handleOpenEditUserModal = (user) => {
    setEditUserModal(true);
    setSelectedUser(user);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  };
  
  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };

  const handleOutsideClick = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setViewStatusOptions({});
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleDropdownClick = (index) => {
    setViewStatusOptions((prev) => {
      const newViewStatusOptions = {};
      newViewStatusOptions[index] = !prev[index];
      return newViewStatusOptions;
    });
  };

  return (
    <>
      {/* {selectAll && (
        <>
          <hr />
          <div className="docpro_data_table_btns">
            <button className="docpro_bordered_btn docpro_fw_600 docpro_primary_color">
              <MessageSquareShare width={20} height={20} />
              Send Bulk SMS
            </button>
            <button className="docpro_bordered_btn docpro_fw_600 docpro_primary_color">
              <FolderOutput width={20} height={20} />
              Export Data
            </button>
            <button className="docpro_bordered_btn docpro_fw_600 docpro_red_color">
              <Trash2 width={20} height={20} />
              Delete
            </button>
          </div>
        </>
      )} */}
      <div className="docpro_table_responsive custom-scroll" style={{ minHeight: '300px' }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th style={{ width: "30px" }}>
                <div
                  className="docpro_checkbox"
                  style={{ top: "3px", marginRight: "8px" }}
                >
                  <input
                    type="checkbox"
                    checked={tableData.length > 0 && selectAll}
                    onChange={handleSelectAll}
                    disabled={tableData.length === 0}
                  />
                  <label></label>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("recipient_email");
                  }}
                  className={
                    orderBy === "recipient_email" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Email <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("expiration_date");
                  }}
                  className={
                    orderBy === "expiration_date" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Expiration Date <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>Roles</th>
              <th>Groups</th>
              <th>
                <div>
                  <div style={styles}>
                    Linked Providers
                  </div>
                </div>
              </th>
              <th className="docpro_text_center"></th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData && tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div className="docpro_checkbox">
                        <input
                          type="checkbox"
                          checked={item.checked || false}
                          onChange={() => handleCheckboxChange(item.id)}
                        />
                        <label></label>
                      </div>
                    </td>
                    <td onClick={() => can_visit("settings_users_invitations_create") && handleOpenEditUserModal(item)}>{item?.recipient_email}</td>
                    <td onClick={() => can_visit("settings_users_invitations_create") && handleOpenEditUserModal(item)}>{convertDateWithSlash(item?.expiration_date)}</td>
                    <td onClick={() => can_visit("settings_users_invitations_create") && handleOpenEditUserModal(item)}>
                      {item.roles.map((item, index) => (
                        <p key={index}>{item}</p>
                      ))}
                    </td>
                    <td onClick={() => can_visit("settings_users_invitations_create") && handleOpenEditUserModal(item)}>
                      {item.groups.map((item, index) => (
                        <p key={index}>{item}</p>
                      ))}
                    </td>
                    <td onClick={() => can_visit("settings_users_invitations_create") && handleOpenEditUserModal(item)}>
                      {/* need html parser to parse the html string */}
                      <div dangerouslySetInnerHTML={{ __html: getProviderNamesByIds(item?.linked_providers || []) }} />
                      {/* {item.accepted ? "Yes" : "No"} */}

                      
                      </td>
                    <td className="docpro_text_center">
                      {(can_visit("settings_users_invitations_create") || can_visit("settings_users_invitations_delete")) && (
                        <div className="docpro_icon_btns">
                          <div className="dropdown-container relative">
                            <button className="docpro_icon_btn" onClick={() => handleDropdownClick(index)}>
                              <EllipsisVertical width={18} height={18} />
                            </button>
                            {viewStatusOptions[index] && (
                              <div className={`docpro_button_toggle_options ${index > 1 && 'top_position'}`}>
                                {(can_visit("settings") && can_visit("settings_users") && can_visit("settings_users_invitations_create")) && (
                                  <button type="button"
                                    className={classNames("docpro_icon_btn docpro_dropdown_button")}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                      setLoading(true);
                                      setSelectedUser(item);
                                      handleResend(item, () => {
                                        setLoading(false);
                                        setSelectedUser({});
                                      });
                                    }}
                                  >
                                    <span className={classNames("", {
                                      docpro_rotating: loading && selectedUser.id === item.id,
                                    })}
                                    style={{ paddingLeft: 0 }}
                                    >
                                      <RefreshCw width={18} height={18} />
                                    </span>
                                    <span>Resend Invitation</span>
                                  </button>
                                )}
                                {(can_visit("settings") && can_visit("settings_users") && can_visit("settings_users_invitations_delete")) && (
                                  <button
                                    className="docpro_icon_btn docpro_dropdown_button docpro_icon_btn_red"
                                    onClick={() => {
                                      setDeleteRecord(item);
                                      setActiveDeleteModal(true);
                                      setPreviousScrollPosition(window.scrollY);
                                      window.scrollTo(0, 0);
                                    }}
                                  >
                                    <Trash2 width={18} height={18} />
                                    <span>Delete</span>
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "300px" }} colSpan="7">
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td style={{ width: "45px" }}> <Skeleton width="1.2rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${3 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5.5 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td className="text-right"> <span className="mr-4 pr-2"><Skeleton width="3rem" borderRadius="8px"></Skeleton></span> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {editUserModal && (
        <EditUserModal
          allProviders={allProviders}
          onClose={handleCloseEditUserModal}
          userData={selectedUser}
          handleDelete={() => {
            setEditUserModal(false);
            handleDeleteRecord(selectedUser.id);
          }}
          handleUpdatedInvitedUserInfo={handleUpdatedInvitedUserInfo}
          userRoles={userRoles}
          editInvitationModal={editUserModal}
        />
      )}

      {activeDeleteModal && (
        <DeleteModal
          handleDelete={() => handleDeleteRecord(deleteRecord?.id)}
          name={deleteRecord?.recipient_email}
          activeModal={activeDeleteModal}
          setActiveModal={setActiveDeleteModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
        />
      )}
    </>
  );
}
